module.exports = __webpack_public_path__ + "static/fonts/sensical_small_kidSafe.svg";